// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:00:32

export default {
  "id": "crazy-descent",
  "slug": "crazy-descent",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d7352091e1f643ffa8370abcaeadd22d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d7352091e1f643ffa8370abcaeadd22d/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Crazy Descent",
      "description": "An exciting race with rivals along the track high in the sky!\nPush your rivals off the track, dodge obstacles and reach the finish line first.\nPump up the car to make the descent even faster.",
      "instructions": "On the phone: swipe left/right\nOn a computer: press W - go forward, press A/D - turn, R - restart\nAvoid obstacles - they destroy the car",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "1player",
        "arcade",
        "car",
        "drift",
        "highway"
      ]
    },
    "zh-CN": {
      "title": "疯狂下降",
      "description": "一场惊心动魄的天空赛道竞速，与对手一较高下！\n推搡对手使其偏离赛道，躲避障碍物，第一个冲过终点线。\n给汽车加力，让下坡速度更快。",
      "instructions": "电话上：左右滑动\n电脑上：按W - 前进，按A/D - 转弯，按R - 重新开始\n避开障碍物 - 它们会摧毁汽车",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "1玩家",
        "街机",
        "汽车",
        "漂移",
        "高速公路"
      ]
    },
    "zh-TW": {
      "title": "瘋狂下降",
      "description": "一場刺激的賽車，與敵手在空中高軌道上競速！推擠敵手出賽道，躲避障礙，並先達終點線。加勁推進車輛，讓下坡更加迅速。",
      "instructions": "電話上：向左/向右滑動\n電腦上：按W - 向前，按A/D - 轉向，按R - 重啟\n避免障礙物 - 它們會毀壞汽車",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "1玩家",
        "街機",
        "車",
        "漂移",
        "高速公路"
      ]
    },
    "zh-HK": {
      "title": "瘋狂下降",
      "description": "一場刺激的空中跑道競賽，與對手一較高下！將對手推離跑道，避開障礙物，率先衝線。提升汽車速度，讓下降更加迅速。",
      "instructions": "在電話上：向左/右掃滑\n在電腦上：按 W - 向前，按 A/D - 轉向，按 R - 重啟\n避開障礙物 - 他們會摧毀汽車",
      "genres": [
        "休闲",
        "賽車及駕駛"
      ],
      "tags": [
        "1玩家",
        "街機",
        "車",
        "滑漂",
        "高速公路"
      ]
    },
    "ja": {
      "title": "クレイジー・ディスセント",
      "description": "空高く走るトラック上での興奮的なレース！ライバルをトラックから押し出し、障害物を避け、最初にゴール線に達する。\n車をパワーアップして、下降をさらに速くする。",
      "instructions": "電話で：左/右にスワイプ\nコンピュータで：Wキーを押す - 前進、A/Dキーを押す - 転がる、Rキーを押す - リスタート\n障害物を避け - それらは車を破壊します",
      "genres": [
        "カジュアル",
        "レーシング & ドライビング"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "車",
        "ドリフト",
        "高速道路"
      ]
    },
    "ko": {
      "title": "쿠레이지 데스센트",
      "description": "하늘 높이 달리는 라이벌들과의 흥미진진한 경주!\n라이벌들을 트랙에서 내리쳐, 장애물을 피하고 최초로 목적지에 도달하세요.\n차량을 공급하여 내리막을 더 빠르게 달리게 하세요.",
      "instructions": "전화기에서: 왼쪽/오른쪽으로 스와이프\n컴퓨터에서: W키 누르기 - 앞으로 가기, A/D키 누르기 - 돌기, R키 누르기 - 재시작\n충돌물 피하기 - 차를 파괴합니다",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "자동차",
        "드리프트",
        "고속도로"
      ]
    },
    "fr": {
      "title": "Dégringolade Folle",
      "description": "Une course passionnante avec des rivaux le long de la piste en haut du ciel !\nÉloigne tes rivaux de la piste, esquives les obstacles et atteins la ligne d'arrivée en premier.\nAmplifie la vitesse de ta voiture pour accélérer la descente.",
      "instructions": "Au téléphone : glisser à gauche/droite\nSur un ordinateur : appuyer sur W - avancer, appuyer sur A/D - tourner, R - redémarrer\nÉviter les obstacles - ils détruisent la voiture",
      "genres": [
        "Loisir",
        "Course et Conduite"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "voiture",
        "drift",
        "autoroute"
      ]
    }
  }
};
